import api from "@/api";
import {
    EwsResponse,
    EwsRequest,
    CalendarRequestData,
    CalendarEventResponseData,
    BirthdayEmployeeInfo,
    CompanyHoliday,
    VacationerInfo,
    EwsCalendarFolder,
} from "./types";

export default {
    getCalendarEvents(request: CalendarRequestData) {
        return api.post<CalendarEventResponseData[]>({
            url: "/Mail/Calendar/api/getList?funcName=getCalendarEventListWithRecurrence",
            data: request,
        });
    },

    getUnReadMail(): Promise<ewsResponse.ewsMail[]> {
        return api
            .post<EwsResponse<ewsResponse.ewsMail>>({
                url: "/Mail/Folder/api/unreadmail",
            })
            .then((res) => {
                return res.items;
            });
    },

    getCalendars(): Promise<EwsCalendarFolder[]> {
        return api
            .get<EwsResponse<EwsCalendarFolder>>({
                url: "/Mail/Calendar/api/list",
            })
            .then((res) => {
                return res.items;
            });
    },

    getEWSData<T>(request: EwsRequest): Promise<T[]> {
        return api
            .post<EwsResponse<T>>({
                url: '/Mail/Dynamic/api/list',
                data: request,
            })
            .then(res => {
                return res.items;
            });
    },

    getCompanyEvents(comCode: string, start: string, end: string): Promise<CompanyHoliday[]> {
        return api.get({
            url: `/Common/Holiday/api/listByDate?comCode=${comCode}&start=${start}&end=${end}`,
        });
    },

    getBirthdayPeopleInMonth(startDate: string, endDate: string): Promise<BirthdayEmployeeInfo[]> {
        return api.get({
            url: `/Feelanet/Hr/api/BirthDayEmployeeInMonth?start=${startDate}&end=${endDate}`,
        });
    },

    getBirthdayPeopleInDay(date: string): Promise<BirthdayEmployeeInfo[]> {
        return api.get({
            url: `/Feelanet/Hr/api/BirthDayEmployeeInDay?birthDate=${date}`,
        });
    },

    getVacationersInMonth(startDate: string, endDate: string): Promise<VacationerInfo[]> {
        return api.get({
            url: `/hr/vacationer/api/getByMonth?startDate=${startDate}&endDate=${endDate}`
        })
    },

    getVacationersInDay(date: string): Promise<VacationerInfo[]> {
        return api.get({
            url: `/hr/vacationer/api/getByDate?date=${date}`,
        });
    },
};
